import React from 'react';

interface DisconnectItem {
  type: 'ap_archetype' | 'governance_overlay';
  id: string;
  name: string;
  customerId: string;
}

interface DisconnectConfirmationModalProps {
  isOpen: boolean;
  disconnectItem: DisconnectItem | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DisconnectConfirmationModal: React.FC<DisconnectConfirmationModalProps> = ({
  isOpen,
  disconnectItem,
  onClose,
  onConfirm,
}) => {
  if (!isOpen || !disconnectItem) return null;

  const itemType = disconnectItem.type === 'ap_archetype' ? 'AP archetype' : 'governance overlay';
  const itemColor = disconnectItem.type === 'ap_archetype' ? 'purple' : 'orange';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Confirm Disconnect</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
            <div className={`w-10 h-10 rounded-full bg-${itemColor}-100 flex items-center justify-center`}>
              {disconnectItem.type === 'ap_archetype' ? (
                <svg className={`w-5 h-5 text-${itemColor}-600`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              ) : (
                <svg className={`w-5 h-5 text-${itemColor}-600`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              )}
            </div>
            <div>
              <div className="font-medium text-gray-900">{disconnectItem.name}</div>
              <div className="text-sm text-gray-500 capitalize">{itemType}</div>
            </div>
          </div>

          <p className="text-gray-600">
            Are you sure you want to disconnect <strong>{disconnectItem.name}</strong> from this customer? 
            This action cannot be undone.
          </p>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`px-4 py-2 rounded-md transition-colors bg-${itemColor}-600 text-white hover:bg-${itemColor}-700`}
            >
              Disconnect
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisconnectConfirmationModal;
